export default function NormalEditIcon({ color = "#AFBACA" }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 14.1874H1.875C1.72582 14.1874 1.58274 14.1282 1.47725 14.0227C1.37176 13.9172 1.3125 13.7741 1.3125 13.6249V10.4829C1.3125 10.409 1.32705 10.3359 1.35532 10.2677C1.38359 10.1994 1.42502 10.1374 1.47725 10.0852L9.91475 1.64766C10.0202 1.54217 10.1633 1.48291 10.3125 1.48291C10.4617 1.48291 10.6048 1.54217 10.7102 1.64766L13.8523 4.78967C13.9577 4.89516 14.017 5.03823 14.017 5.18742C14.017 5.3366 13.9577 5.47967 13.8523 5.58516L5.25 14.1874ZM5.25 14.1874H13.6875M5.25 14.1874L1.34829 10.2857M8.0625 3.49992L12 7.43742"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
